import { apiRequest } from "../api/client";
import type { ServiceType } from "./types";
export interface BookingListRow {
  id: string;
  reference: string;
  customer: string;
  experience: string;
  orderNumber: string;
  date: string;
  time: string;
  guests: number;
  status: string;
  paid: boolean;
  payment?: { status: string; total: number|null; received: number|null; balance: number|null; overdue: boolean; currency: string } | undefined;
  confirmationError?: string;
  confirmationStatus?: string;
  service: ServiceType;
}
export interface BookingDirectory {
  data: BookingListRow[];
  pagination: { page: number; perPage: number; total: number };
}
export async function bookingDirectory(input: {
  service?: ServiceType | undefined;
  page: number;
  search: string;
  status: string;
}): Promise<BookingDirectory> {
  const params = new URLSearchParams({
    page: String(input.page),
    per_page: "50",
  });
  if (input.service) params.set("service_type", input.service);
  if (input.status !== "all") params.set("status", input.status);
  if (input.search.trim()) params.set("search", input.search.trim());
  const result = await apiRequest<{
    data: Record<string, unknown>[];
    pagination: {
      page: number;
      perPage?: number;
      per_page?: number;
      total: number;
    };
  }>(`/api/v1/bookings?${params}`);
  return {
    data: result.data.map((row) => {
      const service = (input.service ?? String(row.service_type)) as ServiceType;
      return {
      id: String(row.source_id),
      reference: `RES-${row.source_id}`,
      customer: String(row.customer_name ?? "Cliente"),
      experience:
        service === "balloon"
          ? "Vuelo en globo"
          : service === "tour"
            ? "Tour"
            : "Grupo escolar",
      orderNumber: String(row.order_number ?? "—"),
      date: String(row.booking_date).slice(0, 10),
      time: String(row.booking_time ?? "").slice(0, 5),
      guests: Number(row.people_count),
      status: String(row.status),
      paid: ["processing", "completed"].includes(String(row.order_status)),
      payment: row.payment_status == null ? undefined : {
        status: String(row.payment_status), total: row.contract_total == null ? null : Number(row.contract_total),
        received: row.paid_amount == null ? null : Number(row.paid_amount), balance: row.balance_due == null ? null : Number(row.balance_due),
        overdue: Boolean(row.balance_overdue), currency: String(row.currency ?? 'MXN'),
      },
      confirmationStatus: String(row.confirmation_status ?? ''),
      confirmationError: String(row.confirmation_error ?? ''),
      service,
    };
    }),
    pagination: {
      page: result.pagination.page,
      perPage: result.pagination.perPage ?? result.pagination.per_page ?? 50,
      total: result.pagination.total,
    },
  };
}
